import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api-base';

export interface MonitoringDailyRow {
  date: string;
  label: string;
  value: number;
}

export interface MonitoringTenantRow {
  tenant_id: number | null;
  tenant_name: string;
  accesses: number;
}

export interface MonitoringSystemResponse {
  period_days: number;
  users_by_day: MonitoringDailyRow[];
  accesses_by_day: MonitoringDailyRow[];
  top_tenants: MonitoringTenantRow[];
}

@Injectable({
  providedIn: 'root'
})
export class ControlmonitorService {
  constructor(private http: HttpClient) {}

  getSystemMonitoring(tenantId: number): Observable<MonitoringSystemResponse> {
    const params = new HttpParams().set('tenant_id', String(tenantId));
    return this.http.get<MonitoringSystemResponse>(`${API_BASE_URL}/monitoring/system`, { params });
  }
}

